'use strict';

import {chooseBonusProducts} from './bonusProducts';
import * as progress from '../components/progress';
import * as productUtils from './productUtils';
import * as miniCart from '../components/miniCart';
import modules from '../helpers/modules';
import {createElWithAttrs} from '@borngroup/born-utilities';
import {getQueryStringParams} from '../helpers/urlUtilities';
import {_handleAddToCartButtonStatus} from '../product/caseRefills';

/**
 * Returns the first option value ID available.
 * @param  {[type]} options [description]
 * @return {[type]}         [description]
 */
function _getOptionValueID(options) {
    let optionsArray = options && options.length ? JSON.parse(options) : null;

    return optionsArray && optionsArray[0] ? optionsArray[0].selectedValueId : null;
}

/**
 * Compatibility between NEMER & US/CA
 * @param {*} productData
 */
function isProductSellable(productData) {
    if (productData.sellable.hasOwnProperty('web')) {
        return productData.sellable.web;
    }

    return (productData.available && productData.sellable) ? true : false;
}

/**
 * Render the ApplePay button if the item is ready to be added to cart,
 * otherwise enable/disable as needed.
 */
function _handleApplePay(productData, productContainer) {
    let applePayButton = productContainer.querySelector('.js--apple-pay'),
        sellable = isProductSellable(productData);

    if (productData.readyToOrder && productData.available && sellable) {
        if (applePayButton) {
            applePayButton.setAttribute('sku', productData.id);
            applePayButton.disabled = false;
        } else {
            let addToCartContainer = productContainer.querySelector('[data-product-component="add-container"]');

            createElWithAttrs(addToCartContainer, {class: 'product-add__button apple-pay-pdp button button--apple-pay set--w-100 js--apple-pay', sku: productData.id}, 'isapplepay');
        }
    } else if (applePayButton) {
        applePayButton.disabled = true;
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
export function handlePostCartUpdate(formData, response) {
    miniCart.updateMinicartCount(response.quantityTotal);
    if (response.isProductUpdate) {
        $('body').trigger('product:afterUpdate', {formData, response});
    } else {
        miniCart.openMinicart(true);
        if ( /Android|webOS|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent) && window.innerWidth <= 1024) {
            $('.product-tile__quickshop-options-close-btn').trigger('click');
        }

        const configuratorType = new URLSearchParams(window. location. search).get('ref');
        modules.tracking.init(null, {
            trackEvent: 'addToCart',
            trackObject: {
                asyncURL: window.SFRA.Urls.GTMEventView,
                asyncParams: {
                    configuratorType: configuratorType,
                    pid: formData.pid,
                    setProductData: formData.pidsObj,
                    qty: formData.quantity,
                    pliUUID: response.pliUUID
                }
            }
        });
    }
    $('body').trigger('product:afterAddToCart', {formData, response});
    $('#itemAdd-' + response.pliUUID).text(`Another ${response.cart.items[0].productName} has been added successfully`);
    $('#addItemAlert-' + response.pliUUID).prop('role', 'alert');
    // show add to cart toast
    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    }

    progress.hideLoader();
    if (this.dataset.updateCart && document.querySelector('[data-action="Cart-Show"]')) {
        window.location.reload();
    }

    if (document.querySelector('[data-product-personalisation="VASDescAddStrap"]') != null) {
        let textNone = document.querySelector('[data-product-personalisation="VASDescAddStrap"]').dataset.messageNone;
        $('[data-product-personalisation="VASDescAddStrap"]').text(textNone);
        $('[data-product-personalisation-addstrap="remove"]').addClass('hidden');
    }
}

export function handleCartAdd(currentContext, formData = {}) {
    let productContainer = productUtils.getProductContainer(currentContext),
        productType = productUtils.getProductType(productContainer),
        childProducts = productUtils.getChildProducts(productContainer),
        addToCartUrl = formData.addToCartUrl || currentContext.getAttribute('data-url') || window.SFRA.Urls.cartAddProduct;

    $('body').trigger('product:beforeAddToCart', currentContext);

    formData.pid = formData.pid || formData.id || productUtils.getPidValue(currentContext);
    formData.uuid = formData.uuid || currentContext.getAttribute('data-uuid');
    formData.quantity = productUtils.getQuantitySelected(currentContext);
    formData.options = productUtils.getOptions(currentContext, true);

    //Use this property to stop an action from adding to cart by passing it on `formData` or through the `product:updateAddToCartFormData` event.
    formData.allowAddToCart = formData.hasOwnProperty('allowAddToCart') ? formData.allowAddToCart : true;

    //SFCC has separate endpoint property names for when it's a Set (pidsObj) vs a Bundle (childProducts)...
    if (productType === 'set') {
        formData.pidsObj = childProducts.data;
    } else if (productType === 'bundle') {
        formData.childProducts = childProducts.data;
    }

    //The `Cart-EditProductLineItem` route expects this property for some reason.
    //The problem is, it was developed to only work with a single option value ID.
    //Hopefully this is corrected on the next update. Issue raised: https://github.com/SalesforceCommerceCloud/storefront-reference-architecture/issues/830
    formData.selectedOptionValueId = _getOptionValueID(formData.options);

    $(currentContext).trigger('product:updateAddToCartFormData', {
        formData,
        childProducts,
        container: productContainer
    });

    if (addToCartUrl && formData.allowAddToCart) {
        progress.showLoader(currentContext);

        $.ajax({
            url: addToCartUrl,
            method: 'POST',
            data: formData,
            success: handlePostCartUpdate.bind(currentContext, formData),
            error: progress.hideLoader
        });
    }
}

/**
 * Handle status for the different product CTAs/messages as the user select their variations.
 */
export function updateAddToCart(productData, productContainer) {
    let isDisabled = !productData.readyToOrder || !productData.available,
        sellable = isProductSellable(productData);
    let isMercury = $('#isMercury').val();
    var addToCartBtn = document.querySelector('.case-refill-req');
    if (addToCartBtn) {
        _handleAddToCartButtonStatus();
    }

    [].forEach.call(productContainer.querySelectorAll('[data-product-component="add-button"]'), function(currentEl) {
        currentEl.disabled = isDisabled;
        if (!currentEl.disabled && productData.size != '') {
            var container = document.querySelector('[data-product-component="selected-refills"]');
            if (container) {
                let refillSels = container.querySelectorAll('[data-sel-refillid]');
                if (refillSels == null || refillSels.length == 0) {
                    currentEl.classList.add('hide-select-size');
                    currentEl.disabled = true;
                }
            }
        } else if (productData.size == '' && currentEl.classList.contains('hide-select-size')) {
            currentEl.classList.remove('hide-select-size');
        }

        if (productData.variationAttributes && productData.variationAttributes[0] && productData.variationAttributes[0].selectedValue == null) {
            currentEl.classList.remove('hidden');
        } else if (productData.options && productData.options[0] && productData.defaultStrapOption == productData.options[0].selectedValueId) {
            for (var i = 0; i < productData.options[0].values.length; i++) {
                if (productData.options[0].values[i].id == productData.options[0].selectedValueId) {
                    if (!sellable || !productData.available || productData.unavailable || productData.options[0].values[i].availability.totalStock == null) {
                        currentEl.classList.add('hidden');
                    } else {
                        currentEl.classList.remove('hidden');
                    }
                    break;
                }
            }
        } else {
            if (productData.available && sellable && productData.isPriceUnderThreshold && productData.readyToOrder) {
                currentEl.classList.remove('hidden');
                if (productData.productType !== 'master' && !productData.requestPrice) {
                    currentEl.classList.remove('disabled');
                }
            } else {
                currentEl.classList.add('hidden');
            }
        }
        if (productData.productType === 'master' && !productData.requestPrice) {
            currentEl.classList.remove('hidden');
            currentEl.classList.add('disabled');
        } else if (productData.productType === 'master' && productData.requestPrice) {
            currentEl.classList.add('hidden');
        }
    });

    [].forEach.call(productContainer.querySelectorAll('[data-product-component="request-price"]'), function(currentEl) {
        if (productData.requestPrice || productData.isPriceUnderThreshold === false) {
            currentEl.classList.remove('hidden');
            $('[data-product-component="availability-status"]').addClass('hidden');
        } else {
            currentEl.classList.add('hidden');
        }
    });

    [].forEach.call(productContainer.querySelectorAll('[data-product-component="stock-availability-status"]'), function(currentEl) {
        var isPlpStockAvailabilityStatus = $(currentEl).data('is-plp-stock-availability-status');
        if (productData.variationAttributes != null) {
            if ((!sellable || !productData.available || productData.unavailable) && !(productData.variationAttributes[0].selectedValue === null && productData.available)) {
                currentEl.classList.remove('hidden');
            } else {
                currentEl.classList.add('hidden');
            }
            if ((!sellable && (!productData.available || productData.unavailable)) && !isPlpStockAvailabilityStatus) {
                currentEl.classList.add('hidden');
                $('[data-product-component="availability-status"]').removeClass('hidden');
            } else {
                $('[data-product-component="availability-status"]').addClass('hidden');
            }
        } else if (productData.options && productData.options[0] && productData.defaultStrapOption == productData.options[0].selectedValueId) {
            for (var i = 0; i < productData.options[0].values.length; i++) {
                if (productData.options[0].values[i].id == productData.options[0].selectedValueId) {
                    if (!sellable || !productData.available || productData.unavailable || productData.options[0].values[i].availability.totalStock == null) {
                        currentEl.classList.remove('hidden');
                    } else {
                        currentEl.classList.add('hidden');
                    }
                    break;
                }
            }
        } else {
            if ((!sellable || !productData.available || productData.unavailable) ) {
                currentEl.classList.remove('hidden');
            } else {
                currentEl.classList.add('hidden');
            }
        }
        if (productData.productType === 'master') {
            currentEl.classList.add('hidden');
            $('[data-product-component="availability-status"]').addClass('hidden');
        }
        if (productData.requestPrice || productData.isPriceUnderThreshold === false) {
            currentEl.classList.add('hidden');
        }
    });

    [].forEach.call(productContainer.querySelectorAll('[data-applepay-instant-checkout="container"]'), function(currentEl) {
        currentEl.disabled = isDisabled;
        var applepayBtn = $(currentEl).find('.button--apple-pay');
        if (applepayBtn) {
            applepayBtn.attr('sku', productData.id);
        }

        if (productData.productType !== 'master' && productData.available && sellable && productData.readyToOrder && !productData.isCaseProduct && !productData.requestPrice && productData.price.type != 'range') {
            currentEl.classList.remove('hidden');
            $(currentEl).closest('.flex').addClass('flex-flow-wrap');
        } else {
            currentEl.classList.add('hidden');
            $(currentEl).closest('.flex').removeClass('flex-flow-wrap');
        }
    });

    [].forEach.call(productContainer.querySelectorAll('[data-product-component="availability-status"]'), function(currentEl) {
        if ((!sellable || !productData.available || productData.isPriceUnderThreshold === false || productData.unavailable) && !isMercury) {
            currentEl.classList.remove('hidden');
        } else {
            currentEl.classList.add('hidden');
        }
        if (productData.productType === 'master') {
            currentEl.classList.add('hidden');
        }
        if (productData.variationAttributes != null) {
            if (sellable && (!productData.available || productData.unavailable)) {
                currentEl.classList.add('hidden');
            }
        }
        if (productData.requestPrice || productData.isPriceUnderThreshold === false) {
            $('[data-product-component="availability-status"]').addClass('hidden');
        }
    });
    [].forEach.call(productContainer.querySelectorAll('[data-product-component="availability-status-message"]'), function(currentEl) {
        if (productData.productType === 'master' && productData.isDiableSizeSelector) {
            currentEl.classList.add('hidden');
        } else {
            if (productData.productType === 'master' && !productData.isDiableSizeSelector) {
                currentEl.classList.remove('hidden');
            }
        }
    });
    _handleApplePay(productData, productContainer);
}

export function setupAddToCart(container) {
    let addToCartButtons = (container || document).querySelectorAll('[data-product-component="add-button"]:not([data-add-ready])');
    let addToCartButtonsSizeSelected = (container || document).querySelectorAll('[data-product-component="size-select-warning"]');

    [].forEach.call(addToCartButtons, function(currentBtn) {
        currentBtn.setAttribute('data-add-ready', '');

        currentBtn.addEventListener('click', function() {
            let formData = getQueryStringParams(window.location.search);
            handleCartAdd(this, formData);
        })
    });
    [].forEach.call(addToCartButtonsSizeSelected, function(currentBtn) {
        currentBtn.addEventListener('click', function() {
            let selectSizeEle = $('.pdp-select-size .product-attribute__size');
            $('html, body').animate({
                scrollTop: selectSizeEle.offset().top - ( selectSizeEle.height() + $('.header-container').height() )
            }, 1000);
        })
    });
}
